import { render, staticRenderFns } from "./addpersonnel.vue?vue&type=template&id=049b92f1&scoped=true"
import script from "./addpersonnel.vue?vue&type=script&lang=js"
export * from "./addpersonnel.vue?vue&type=script&lang=js"
import style0 from "./addpersonnel.vue?vue&type=style&index=0&id=049b92f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049b92f1",
  null
  
)

export default component.exports